// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__36qKf","imageSection":"NotFound_imageSection__vAKos"};